import { gql } from "@apollo/client";

export const BULK_PRINT_OFFERS_EXECUTED = gql`
  subscription bulkPrintOffersExecuted {
    bulkPrintOffersExecuted {
      documentId
      siteId
      file {
        filePath
        fileName
      }
    }
  }
`;
